import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { Dropdown } from '../../model/dropdown';
import { AlertModal } from 'src/app/model/alert';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-dropdown',
  templateUrl: './dropdown.component.html',
  styleUrls: ['./dropdown.component.scss']
})
export class DropdownComponent implements OnInit {
  @Input() dropdownConfig;
  @Input() parent: UntypedFormGroup;
  @Input() controlName: string;
  @Input() personalForm;
  @Input() pageName: string;
  @Input() ddDisabled = false;


   @Input() informationRequire = false;
   @Input() informationControlName: string;
   @Input() informationConfig: string;
   textValue:string;
  // tslint:disable-next-line:no-output-on-prefix
  @Output() onChangeHandler: EventEmitter<any> = new EventEmitter<any>();
  @Output() onDisplayMobileTooltipEmitter: EventEmitter<any> = new EventEmitter<any>();
  dropdownControl: UntypedFormGroup;
  public tooltipModalConfig: AlertModal;
  tooltipModal;
  displayTooltipAlert: boolean = false;

  constructor(private fb: UntypedFormBuilder, 
              private activatedRoute: ActivatedRoute) {
    this.tooltipModal = this.activatedRoute.snapshot.data.contentData.tooltipModalConfig;
  }

  ngOnInit() {
   // this.dropdownConfig.defaultValue = this.parent.controls[this.controlName]?.value;


    if(this.parent.get([this.controlName]) && this.pageName == 'beneficiaryDetails'){
      this.textValue = this.parent.get([this.controlName]).value;
    }
    else{
      this.dropdownConfig.defaultValue = this.parent.controls[this.controlName]?.value;
      this.textValue = this.dropdownConfig.defaultValue;
    }
  }


  /* common method for converting string into camel case */
  toCamelCase(id_value) {
    return id_value.toLowerCase()
      // Replaces any - or _ characters with a space
      .replace(/[-_]+/g, ' ')
      // Removes any non alphanumeric characters
      .replace(/[^\w\s]/g, '')
      // Uppercases the first character in each group immediately following a space
      // (delimited by spaces)
      .replace(/ (.)/g, function ($1) { return $1.toUpperCase(); })
      // Removes spaces
      .replace(/ /g, '');
  }
  onChange = () => {
    this.dropdownConfig.defaultValue = this.parent.controls[this.controlName]?.value;
    this.textValue = this.dropdownConfig.defaultValue;
    this.onChangeHandler.emit();
  }
 




  displayDrpTooltipMessage(){
    this.onDisplayMobileTooltipEmitter.emit();
  }


}
